import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Layout from "../../../../Layout/Layout";
import { useNavigate } from "react-router-dom";
import Constants from "../../../../common/CustomerConstants";

//Redux
import { useSelector } from "react-redux";
import { InputField } from "../../../../Components/formElements/InputField";

//Serivce
import ItemService from "../../../../services/customer_appCommonService";
import DataTable from "react-data-table-component";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
import { formatDate, getTodaysData } from "../../../../common/Validations";
import CustomerConstants from "../../../../common/CustomerConstants";
import { useCallback } from "react";

const IndentDetailPageV2 = () => {
  const navigate = useNavigate();
  localStorage.setItem("menu", "Project");
  localStorage.setItem("submenu", "Indent");

  let inquiryID = useSelector((state) => state?.preSales?.inquiryID); // User Details from Store
  let userData = useSelector((state) => state?.user?.data); // User Details from Store

  const [formInputs, setFormInputs] = useState({
    manualIndicator: true,
    manualRelease: true,
    initiatorName: userData?.data?.firstName,
    initiator: userData?.data?.userId,
    indentDocumentType: "IN",
    version: "V0",
    inqHeaderstatus: "New",
    salesDocumentGroup: "IN",
    customerCode: userData?.data?.userId,
    customerName: userData?.data?.firstName,
    indentCategory: "",
    indentDocumentDate: getTodaysData() || "",
    requestDeliveryDate: "",
    salesOrg: "",
    salesGroup: "",
    companyCode: "",
    qtUpdateRemark: "",
    purchasingReqDocumentValue: "",
    indentRemark: "",

    headerTextData: [
      {
        itemIndex: "",
        documentId: "",
        documentText: "",
      },
    ],

    items: [
      {
        indentDocumentItemNr: "",
        itemTextData: [
          {
            itemIndex: "",
            documentId: "",
            documentText: "",
          },
        ],
        materialCode: "",
        inqItemStatus: "New",
        materialDescription: "",
        materialGroup: "",
        indentQuantity: "",
        orderUnitOfMeasure: "",
        orderPriceUnit: "",
        netValue: "",
        // deliveryDate: "",
        itemCurrency: "",
        storageLocn: "",
        taxCode: 0,
        taxAmount: 0,
      },
    ],
  });

  let POLineItemInitialData = [
    {
      local_id: 1,
      indentDocumentItemNr: 1,
      itemTextData: [],
      inqItemStatus: "In Release",
      indentQuantity: "",
      orderPriceUnit: 0,
      taxCode: 0,
      taxAmount: 0,
      netValue: 0,
      remark: "",
    },
  ];

  const [getPOLineItemsData, setPOLineItemsData] = useState(
    POLineItemInitialData
  );
  const [isCardVisible, setCardVisible] = useState(true);
  // View attachment files

  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);

  const [editMode, setEditMode] = useState(true);

  const IdentUpdates = () => {
    setEditMode(false);
  };

  const cancelUpdate = () => {
    setEditMode(true);
  };

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };

  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  const [getDisabledStatus, setDisabledStatus] = useState(true);
  const [disabled, setDisabled] = useState(false);

  const loadFirstLevelData = async (page) => {
    if (inquiryID) {
      let obj = {
        documentNumber: inquiryID,
      };
      await ItemService.getInquiryDetail(obj).then((item) => {
        if (item?.status === 200) {
          setDisabledStatus(true);
          setFormInputs(item?.data[0]);
          setPOLineItemsData(item?.data[0]?.items);
        } else {
          setFormInputs([]);
          console.log(">> Error: Loading getCategory");
        }
      });
    } else {
      navigate(Constants.PRESALES_INQUIRY_LIST);
    }
  };
  const handleUpdate = async () => {
    const obj = {
      ...formInputs,
      items: getPOLineItemsData,
    };
    await ItemService.updateInquiryDetail(obj).then((item) => {
      if (item?.status === 200) {
        toast.success(item?.message || "Updated successfully", {
          duration: 2000,
          position: "top-right",
        });
        navigate(CustomerConstants.CUSTOMER_V2_INDENT_LIST);
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
  };

  useEffect(() => {
    loadFirstLevelData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Commmon OnChange of the input scetion
  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
  };
  const handleInputChange = useCallback((indentDocumentItemNr, event) => {
    const { name, value } = event.target;

    setPOLineItemsData((prevItems) =>
      prevItems.map((item) =>
        item.indentDocumentItemNr === indentDocumentItemNr
          ? { ...item, [name]: value }
          : item
      )
    );
  }, []);

  const getPOLineItemColumns = useCallback(
    (editMode) => [
      {
        name: "Item Nr",
        selector: (row) => row.local_id || "--",
        sortable: true,
        width: "180px",
      },
      {
        name: "Material/Service",
        selector: (row) => row.materialCode || "--",
        cell: (row) => (
          <InputField
            className="inputBox mt-1"
            name="materialCode"
            value={row.materialCode || ""}
            onChange={(e) => handleInputChange(row.local_id, e)}
            disabled
          />
        ),
        sortable: true,
        width: "200px",
      },
      {
        name: "Description",
        selector: (row) => row.materialDescription || "--",
        cell: (row) => (
          <TextAreaField
            className="inputBox mt-1"
            name="materialDescription"
            placeholder=""
            value={row.materialDescription || ""}
            onChange={(event) => handleInputChange(row.local_id, event)}
            disabled
          />
        ),
        sortable: true,
        width: "200px",
      },

      {
        name: "Quantity",
        selector: (row) => row.indentQuantity || "--",
        cell: (row) => (
          <InputField
            className="inputBox mt-1"
            name="indentQuantity"
            value={row.indentQuantity || ""}
            onChange={(e) => handleInputChange(row.indentDocumentItemNr, e)}
            disabled={editMode}
          />
        ),
        sortable: true,
        width: "200px",
      },
    /*   ...(userData?.category === "SALES"
        ? [
            {
              name: "Remark",
              selector: (row) => row.qtUpdateRemark,
              cell: (row) => (
                <InputField
                  className="inputBox mt-1"
                  name="qtUpdateRemark"
                  value={row.qtUpdateRemark || ""}
                  onChange={(e) =>
                    handleInputChange(row.indentDocumentItemNr, e)
                  }
                  disabled={editMode}
                />
              ),
              sortable: true,
              width: "200px",
            },
          ]
        : []), */
      {
        name: "UOM",
        selector: (row) => row.orderUnitOfMeasure || "--",
        cell: (row) => (
          <InputField
            className="inputBox mt-1"
            name="orderUnitOfMeasure"
            value={row.orderUnitOfMeasure || ""}
            onChange={(e) => handleInputChange(row.local_id, e)}
            disabled
          />
        ),
        width: "200px",
      },
      {
        name: "Site Location",
        selector: (row) => row.storageLocn || "--",
        cell: (row) => (
          <InputField
            className="inputBox mt-1"
            // label="Please Enter the Remarks*"
            name="storageLocn"
            placeholder=""
            value={row.storageLocn || ""}
            onChange={(event) => handleInputChange(row.local_id, event)}
            disabled
          />
        ),
        sortable: true,
        width: "200px",
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [handleInputChange, userData]
  );
  const [getPOLineItemsCol, setPOLineItemsCol] = useState(
    getPOLineItemColumns(editMode)
  );

  useEffect(() => {
    setPOLineItemsCol(getPOLineItemColumns(editMode));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editMode]);

  useEffect(() => {
    const columns = getPOLineItemColumns(editMode);
    setPOLineItemsCol(columns);
  }, [editMode, getPOLineItemColumns]);

  // Onclick on Table Header Button
  const handleAcknowledgeClick = async () => {
    let obj = {
      inquiryNr: formInputs.inquiryNr,
    };

    // // if (getSelectedData.length > 0) {
    await ItemService.acknowledgeInquiry(obj).then((item) => {
      if (item?.status === 200) {
        toast.success(item?.message || "Indent Acknowledged successfully", {
          duration: 3000,
          position: "top-right",
        });

        setDisabled(true);
        loadFirstLevelData();
      } else {
        console.log("Indent Acknowledged Not successfully");
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner timesheet">
            <h2 className="mainTitle">
              Indent Details :{" "}
              <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                {inquiryID}
              </span>
              <span>
                {formInputs?.inqHeaderstatus === "Pending" ? (
                  <span className="bg-table-status bg-table-info-status headerStatusDetailedPage">
                    {formInputs?.inqHeaderstatus}
                  </span>
                ) : formInputs?.inqHeaderstatus === "In Progress" ? (
                  <span className="bg-table-status bg-table-new-status headerStatusDetailedPage">
                    {formInputs?.inqHeaderstatus}
                  </span>
                ) : formInputs?.inqHeaderstatus === "New" ? (
                  <span className="bg-table-status bg-table-new-status headerStatusDetailedPage">
                    {formInputs?.inqHeaderstatus}
                  </span>
                ) : formInputs?.inqHeaderstatus === "Completed" ? (
                  <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                    {formInputs?.inqHeaderstatus}
                  </span>
                ) : formInputs?.inqHeaderstatus === "Acknowledged" ? (
                  <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                    {formInputs?.inqHeaderstatus}
                  </span>
                ) : formInputs?.inqHeaderstatus === "Deactivated" ? (
                  <span className="bg-table-status bg-table-danger-status headerStatusDetailedPage">
                    {formInputs?.inqHeaderstatus}
                  </span>
                ) : (
                  formInputs?.inqHeaderstatus
                )}

                {formInputs?.indentTypeCode === "DIR" ? (
                  <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                    {formInputs?.indentType}
                  </span>
                ) : formInputs?.indentTypeCode === "OFF" ? (
                  <span className="bg-table-status bg-table-new-status headerStatusDetailedPage">
                    {formInputs?.indentType}
                  </span>
                ) : (
                  formInputs?.indentType
                )}
              </span>
            </h2>
            <p className="subText">Indent Information </p>
            <hr />
            <Row className="mb-4">
              {/* edit button */}
              {editMode &&
                formInputs?.inqHeaderstatus === "New" &&
                userData?.category === "SALES" && (
                  <Col
                    xs={6}
                    md={{ span: 2, offset: 10 }}
                    lg={{ span: 2, offset: 10 }}
                    className="text-left"
                  >
                    <Col xs={6} md={2} lg={2} className="text-left">
                      <button className="btnInfo" onClick={IdentUpdates}>
                        Edit
                      </button>
                    </Col>
                  </Col>
                )}
              {!editMode && (
                <Col
                  xs={6}
                  md={{ span: 2, offset: 8 }}
                  lg={{ span: 2, offset: 8 }}
                  className="text-left "
                  onClick={handleUpdate}
                >
                  <button className="btnInfo">Update</button>
                </Col>
              )}
              {!editMode && (
                <Col xs={6} md={2} lg={2} className="text-left">
                  <button className="btnInfo btn-danger" onClick={cancelUpdate}>
                    Cancel
                  </button>
                </Col>
              )}
            </Row>

            {/* 01 */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">HD</span>
                    </Col>
                    <Col xs={12} md={8} lg={8}>
                      <span className="headerTitle">Header Details</span>
                      <span className="subHeaderTitle">
                        Indent Basic Information
                      </span>
                    </Col>

                    {formInputs?.inqHeaderstatus === "Acknowledged" &&
                      userData?.category === "SALES" && (
                        <Col xs={1} md={2} lg={2} className="">
                          {/* <button className="btnTable" onClick={createQuotation}>
                          <i className="bi bi-cart-check"></i> Create Quotation
                        </button> */}
                        </Col>
                      )}
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Indent No"
                          name="inquiryNr"
                          extraLabel=""
                          placeholder=""
                          value={formInputs.inquiryNr || ""}
                          onChange={onInputChange}
                          disabled={getDisabledStatus}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Status"
                          name="inqHeaderstatus"
                          placeholder=""
                          value={formInputs.inqHeaderstatus || ""}
                          onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Order Type"
                          name="orderType"
                          placeholder=""
                          value={formInputs.salesType || ""}
                          onChange={onInputChange}
                          disabled={getDisabledStatus}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          id="companyCode"
                          className="inputBox"
                          label="Company Code"
                          name="companyCode"
                          placeholder=""
                          value={formInputs?.companyCode}
                          onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          id="requestDeliveryDate"
                          className="inputBox"
                          label="Request Delivery Date"
                          name="requestDeliveryDate"
                          placeholder=""
                          type="date"
                          value={formInputs?.requestDeliveryDate}
                          onChange={onInputChange}
                          disabled={getDisabledStatus}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          id="indentType"
                          className="inputBox"
                          label="Indent Type"
                          name="indentType"
                          placeholder=""
                          type="text"
                          value={formInputs?.indentType}
                          onChange={onInputChange}
                          disabled={getDisabledStatus}
                        />
                      </Col>
                      {formInputs?.indentTypeCode === "DIR" && (
                        <>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="vendorName"
                              className="inputBox"
                              label="Venodr Name"
                              name="vendorName"
                              placeholder=""
                              type="text"
                              value={formInputs?.vendorName}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <TextAreaField
                              id="venodrAddress"
                              className="inputBox"
                              label="Venodr Address"
                              name="venodrAddress"
                              placeholder=""
                              value={formInputs.venodrAddress || ""}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                        </>
                      )}
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          id="buildingRequirements"
                          className="inputBox"
                          label="Building Requirements"
                          name="buildingRequirements"
                          placeholder=""
                          type="text"
                          value={formInputs?.buildingRequirements}
                          onChange={onInputChange}
                          disabled={getDisabledStatus}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <TextAreaField
                          id="siteAddress"
                          className="inputBox"
                          label="Site Address"
                          name="siteAddress"
                          placeholder=""
                          value={formInputs.siteAddress || ""}
                          onChange={onInputChange}
                          disabled={getDisabledStatus}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Request Delivery Date"
                          name="requestDeliveryDate"
                          placeholder=""
                          // value={formInputs?.requestDeliveryDate || ""}
                          value={
                            formatDate(formInputs?.requestDeliveryDate) || ""
                          }
                          onChange={onInputChange}
                          disabled={getDisabledStatus}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <TextAreaField
                          className="inputBox"
                          label="Remark"
                          type="text"
                          name="inquiryRemark"
                          id="inquiryRemark"
                          placeholder=""
                          value={formInputs?.indentRemark || ""}
                          onChange={onInputChange}
                          disabled={getDisabledStatus}
                        />
                      </Col>
                      <Col
                        xs={2}
                        md={2}
                        lg={2}
                        className="commLeftRightPadding"
                      >
                        <p className="fw-medium">Supporting Document</p>
                        {(formInputs.supportingDoc && (
                          <img
                            src="assets/img/newIcons/attached-file.png"
                            className="mt-1 attachmentIcon"
                            alt="attachments"
                            onClick={() =>
                              handleViewFile(formInputs.supportingDoc)
                            }
                          />
                        )) ||
                          "--"}
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* Price Shedule / Line Item */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">LI</span>
                    </Col>
                    <Col xs={12} md={3} lg={3}>
                      <span className="headerTitle">Line Item / Products</span>
                      <span className="subHeaderTitle">
                        Line Item / Products Details
                      </span>
                    </Col>
                    <Col
                      xs={12}
                      md={8}
                      lg={8}
                      className="headerButtonAlign"
                    ></Col>
                    {formInputs?.inqHeaderstatus === "New" &&
                      userData?.category === "SALES" && (
                        <Col xs={1} md={2} lg={2} className="">
                          <button
                            className="btnTable"
                            onClick={() => handleAcknowledgeClick()}
                            disabled={disabled}
                          >
                            Acknowledged
                          </button>
                        </Col>
                      )}
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    {" "}
                    {/* dynamicDropdown */}
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={getPOLineItemsCol}
                          data={getPOLineItemsData}
                          // progressPending={loading}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          // paginationServer
                          // paginationTotalRows={totalRows}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          selectableRows
                          // onSelectedRowsChange={handleChange}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />
    </main>
  );
};

export default IndentDetailPageV2;
